var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Wallet--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Wallet Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet--money-payment-finance-wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.9 9.695V11.655C11.9 11.9149 11.7967 12.1642 11.613 12.348S11.1799 12.635 10.92 12.635H1.61C1.3501 12.635 1.1008 12.5317 0.917 12.348C0.7333 12.1642 0.63 11.9149 0.63 11.655V4.305C0.63 2.6813 1.9463 1.365 3.57 1.365H9.94V3.815",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.88 6.755H9.45C9.1794 6.755 8.96 6.9744 8.96 7.245V9.205C8.96 9.4756 9.1794 9.695 9.45 9.695H12.88C13.1506 9.695 13.37 9.4756 13.37 9.205V7.245C13.37 6.9744 13.1506 6.755 12.88 6.755Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.9 6.755V4.795C11.9 4.5351 11.7967 4.2858 11.613 4.102C11.4292 3.9183 11.1799 3.815 10.92 3.815H3.57",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuWallet);
export default __webpack_public_path__ + "static/media/menu-wallet.147bc751e7eb6e3e467cec5cc26a9f39.svg";
export { ForwardRef as ReactComponent };